// extracted by mini-css-extract-plugin
module.exports = {"TableNoRowers":"StudentRegistrations_TableNoRowers__3Gxit"};